"use client";

import { useTranslations } from "next-intl";
import { ReadMoreBlock } from "@/components/ReadMoreBlock";

export function ServicesDepthIntroExpandable({
  className = "mt-5 max-w-[40rem]",
}: {
  className?: string;
} = {}) {
  const t = useTranslations("servicesHub");

  return (
    <ReadMoreBlock
      className={className}
      linksClassName="mt-3 flex flex-wrap items-baseline gap-x-5 gap-y-1.5"
      collapsedContent={
        <p
          className="text-[var(--on-surface-variant)] text-[1.0625rem] sm:text-lg leading-relaxed"
          style={{ fontFamily: "var(--font-body)" }}
        >
          {t("depthTeaser")}
        </p>
      }
      expandedContent={
        <p
          className="text-[var(--on-surface-variant)] leading-relaxed text-[1.0625rem] sm:text-lg"
          style={{ fontFamily: "var(--font-body)" }}
        >
          {t("depthExpanded")}
        </p>
      }
    />
  );
}
